module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', {
    staticClass: "headline ma-0 grey--text text--darken-2"
  }, [_vm._v("Texteübersicht")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.mk.total)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.mk.total.length))]), _vm._v(" "), _c('span', [_vm._v("Texte in der WWE MarkenDB")])])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.mk.created)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.mk.created.length))]), _vm._v(" "), _c('span', [_vm._v("Neue Texte seit dem letzten Login")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.mk.updated)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.mk.updated.length))]), _vm._v(" "), _c('span', [_vm._v("Bearbeitete Texte seit dem letzten Login")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7827efb8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/texteCard.vue
// module id = 331
// module chunks = 0